import { useFlags } from '@joor/launchdarkly-react-client-sdk'
import { useSelector } from 'react-redux'

import {
  isLiteRetailer as isListeRetailerSelector,
  isProBrand as isProBrandSelector,
  isAccountTypeRetailer as isRetailerSelector,
} from 'store/currentUser/selectors'

import {
  DATA_SELF_SERVE,
  LIST_JOBS,
  SHOPIFY_RETAILER_SYNC_CONFIG,
} from 'routes/paths'

import DropdownMenuTextLink from '../../DropdownMenuTextLink/DropdownMenuTextLink'
import messages from 'features/Navbar/NavbarRevamp/constants/navbarRevamp.messages'
import { SettingsDropdownIds } from 'features/Navbar/NavbarRevamp/navbarRevamp.ids'

const IntegrationSettings = () => {
  const { retailIntegrationSettings } = useFlags()
  const isProBrand = useSelector(isProBrandSelector)
  const isRetailer = useSelector(isRetailerSelector)
  const isLiteRetailer = useSelector(isListeRetailerSelector)

  if (isProBrand) {
    return (
      <DropdownMenuTextLink
        to={LIST_JOBS}
        message={messages.importsExports}
        id={SettingsDropdownIds.SettingsOptionIntegrations}
      />
    )
  }

  if (isRetailer) {
    const menuItems = []
    if (isLiteRetailer) {
      menuItems.push({
        to: SHOPIFY_RETAILER_SYNC_CONFIG,
        message: messages.integrationSettings,
        id: SettingsDropdownIds.SettingsOptionShopify,
      })
    }
    if (retailIntegrationSettings && !isLiteRetailer) {
      menuItems.push({
        to: DATA_SELF_SERVE,
        message: messages.integrationSettings,
        id: SettingsDropdownIds.SettingsOptionIntegrations,
      })
    }
    return (
      <>
        {menuItems.map(({ to, message, id }) => (
          <DropdownMenuTextLink
            key={id}
            to={to}
            message={message}
            id={id}
            testId={id}
          />
        ))}
      </>
    )
  }

  return null
}
export default IntegrationSettings
